export default __webpack_public_path__ + "static/media/501.961ff747.gif";